export const CONTAINERS = {
  CAN: 'can',
  PET: 'PET',
  BAG: 'bag',
  PACKAGE: 'package'
}
